import React, { useEffect, useState } from 'react'
import queryString from 'query-string'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { APP_ROOT, GET_USER_DETAILS, UPGRADE_TIER_API_PATH } from '../constants/routes'
import { getUserDetails, getUserUploadedDocs } from './api'
import { Tier2Register } from './Tier2Register/Tier2Register'
import { Tier3Register } from './Tier3Register/Tier3Register'
import { Message, Spinner } from '../ui'
import { isEmpty, propOr } from 'ramda'
import { useStore } from '../StateProvider'
import { ResendEmailError } from './ResendEmailError/ResendEmailError'
import { CreateAccount } from './CreateAccount/CreateAccount'
import { TARGET_PLATFORMS } from '../constants/constants'

const platformsWithoutTier3 = [TARGET_PLATFORMS.MT4, TARGET_PLATFORMS.WT, TARGET_PLATFORMS.BP]

const getUserWithOnlyFailedAccounts = (user) => {
  const { jointAccounts } = user
  const newJointAccounts = jointAccounts?.length
    ? jointAccounts.filter(({ docCheckPassed }) => docCheckPassed !== true)
    : jointAccounts
  return {
    ...user,
    jointAccounts: newJointAccounts
  }
}

const UpgradeTier = () => {
  const { t } = useTranslation()
  const [error, setError] = useState({})
  const [isTier3Platform, setIsTier3Platform] = useState(false)
  const [
    {
      whitelabel: { targetPlatform },
      user
    },
    dispatch
  ] = useStore()
  const location = useLocation()

  useEffect(() => {
    const { token = '' } = queryString.parse(location.search)
    const url = token ? `${UPGRADE_TIER_API_PATH}?token=${token}` : GET_USER_DETAILS

    getUserDetails(url).then(
      /**
       * @param {Object} user
       */
      (user) => {
        dispatch({ type: 'setTier', tier: user.tier + 1 })
        if (user.isJointAccount) {
          const userWithOnlyFailedAccounts = getUserWithOnlyFailedAccounts(user)
          if (user.docCheckPassed) {
            dispatch({ type: 'setAccId', accId: 1 })
          }
          dispatch({ type: 'setUser', user: userWithOnlyFailedAccounts })
          dispatch({ type: 'addAccForm', accNumber: 1 })
        } else {
          dispatch({ type: 'setUser', user })
        }

        return getUserUploadedDocs()
      }
    ).then(
      (docs) => {
        const defaultDocsValue = { primary: [], joint: [] }
        dispatch({ type: 'initializeFromStorage', docs: { ...defaultDocsValue, ...docs } })
      }
    )
      /**
       * @param {ErrorCommon} error
       */
      .catch(
        (error) => setError(error))
  }, [])

  useEffect(() => {
    if (targetPlatform) {
      setIsTier3Platform(!platformsWithoutTier3.includes(targetPlatform))
    }
  }, [targetPlatform])

  /**
   * @param {ErrorCommon} error
   */
  const renderForbidden = (error) => (
    <Message title={propOr(t('verifyId.error'), 'message', error)} type='failed'>
      {error.code !== 1004 && <Link to={APP_ROOT}>{t('verifyId.tryAgain')}</Link>}
      {error.code === 1004 && <ResendEmailError />}
    </Message>
  )

  if (!isEmpty(error)) {
    return renderForbidden(error)
  } else if (user.tier === 0) {
    return <CreateAccount />
  } else if (user.tier === 1) {
    return <Tier2Register />
  } else if (user.tier === 2 && user.tierApproveDate && isTier3Platform) {
    return <Tier3Register />
  } else if (user.tier === 2 && !isTier3Platform) {
    return <Message title={t('upgradeTier.completed')} type='success' />
  } else if (user.tier === 2 && !user.tierApproveDate && isTier3Platform) {
    return <Message title={t('upgradeTier.docsSubmitted')} type='success' />
  } else if (user.tier > 2 && !user.tierApproveDate) {
    return <Message title={t('upgradeTier.requestInProgress')} type='success' />
  }

  return <Spinner />
}

export default UpgradeTier
